import { render, staticRenderFns } from "./ProDRankView.vue?vue&type=template&id=10ec3182&scoped=true&"
import script from "./ProDRankView.vue?vue&type=script&lang=js&"
export * from "./ProDRankView.vue?vue&type=script&lang=js&"
import style0 from "./ProDRankView.vue?vue&type=style&index=0&id=10ec3182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec3182",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
